import React from "react";
import Head from "next/head";

export default function Error429({ retryAfter }) {
    const minutes = retryAfter ? Math.ceil(retryAfter / 60) : null;
    return (
        <div>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width,initial-scale=1.0" />
                <meta name="robots" content="noindex,nofollow" />
                <title>Kehila.io | 429</title>
                <link rel="icon" href={"/logo-white.png"} />
            </Head>

            <div style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#0f1115",
                color: "#fff",
                fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
                padding: 24,
                textAlign: "center"
            }}>
                <div style={{ maxWidth: 480 }}>
                    <div style={{ fontSize: 64, fontWeight: 800, letterSpacing: -1, lineHeight: 1 }}>429</div>
                    <h1 style={{ fontSize: 22, fontWeight: 600, marginTop: 16 }}>Trop de requêtes</h1>
                    <p style={{ opacity: .7, marginTop: 12, lineHeight: 1.5 }}>
                        Votre navigateur a envoyé trop de requêtes vers des pages inexistantes.
                        L'accès est temporairement bloqué.
                        {minutes ? ` Merci de réessayer dans environ ${minutes} minute${minutes > 1 ? "s" : ""}.` : ""}
                    </p>
                </div>
            </div>
        </div>
    );
}
